<template>
    <component :is="layout">
        <router-view :layout.sync="layout" />
    </component>
</template>

<script>
import { EmptyLayout, AdminLayout } from '@/layouts';

export default {
    name: 'App',
    components: { EmptyLayout, AdminLayout },
    computed: {
        layout() {
            switch (this.$route.name) {
                case 'error404':
                case 'error500':
                case 'login':
                case 'forgotPassword':
                case null:
                    return EmptyLayout;
                default:
                    return AdminLayout;
            }
        },
    },
    created() {
        // if (!localStorage.getItem('lang')) {
        //     localStorage.setItem('lang', 'en');
        // }
        // this.$i18n.locale = localStorage.getItem('lang');
        this.$i18n.locale = this.$store.state.lang;
    },
};
</script>

<style lang="scss">
@import '@/assets/styles/app.scss';
</style>
